import { connect } from 'react-redux';
import { signOut } from '../../actions/authActions';
import Logout from './Logout';

export default connect(null, { signOut })(Logout);
